const finishButton = document.getElementById('finish-assembly-order');

if (finishButton) {
    finishButton.addEventListener('click', function (event) {
        const hasMissingDocuments = finishButton.getAttribute('data-has-missing-documents') === '1';
        const translatedMessage = finishButton.getAttribute('data-message');
        if (hasMissingDocuments) {
            confirm(translatedMessage);
            const finishButton = document.getElementById('js-confirm-modal').querySelector('.confirm');
            finishButton.addEventListener('click', function (event) {
                document.getElementById('toggle-finish-assembly-order').click();
            });
        }
    });
}
